// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://coydcdtajowjqzcjqrpc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNveWRjZHRham93anF6Y2pxcnBjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkyMjM2MDIsImV4cCI6MjA1NDc5OTYwMn0.wb0dE0QVBLMKxsUik4AMUUEpR1229LuKU0Lnc9ZBMQc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);